/*
  import { ownerAdditionalScheduledPaymentsStore } from '@/services/OwnerAdditionalScheduledPayments/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import { notifyProblem } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await ownerAdditionalScheduledPaymentsStore.dispatch ('getOwnerAdditionalScheduledPaymentsList', {
      ownerID,
      isEligible
    });
  */
  async getOwnerAdditionalScheduledPaymentsList({}, { ownerID, isEligible }) {
    console.log('in getOwnerAdditionalScheduledPaymentsList...')
    try {
      const result = await kms.get('/Roster/OwnerAdditionalScheduledPayment/List', {
        params: {
          ownerID,
          isEligible
        }
      })

      if (isDebug == true)
        console.debug('getOwnerAdditionalScheduledPaymentsList log=' + JSON.stringify(result))

      return {
        list: result.results
      }
    } catch (exception) {
      notifyProblem(`The owner additional Scheduled Payment list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const ownerAdditionalScheduledPaymentsStore = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
